import { RequisitionStatus } from '@recruitee/requisitions-types';

interface SortableByStatus {
  status: RequisitionStatus;
}

const statusOrder = {
  [RequisitionStatus.Draft]: 0,
  [RequisitionStatus.Pending]: 1,
  [RequisitionStatus.Rejected]: 2,
  [RequisitionStatus.Approved]: 3,
  [RequisitionStatus.Filled]: 4,
};

export const statusCompare = (a: SortableByStatus, b: SortableByStatus): number =>
  statusOrder[a.status] - statusOrder[b.status];
